import {extendTheme} from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    body: 'Comfortaa',
    heading: 'Comfortaa',
    mono: 'Comfortaa'
  }
})

export default theme;